import { Form, Select } from '@approvalmax/ui/src/components';
import { FC } from 'react';

import { messages } from './TrackingCategorySelect.messages';
import type { TrackingCategorySelectProps } from './TrackingCategorySelect.types';

export const TrackingCategorySelect: FC<TrackingCategorySelectProps> = (props) => {
    const { name, qa, label, items } = props;

    return (
        <Form.Part>
            <Select
                name={name}
                itemNameKey='text'
                qa={qa}
                label={label}
                placeholder={messages.placeholder}
                items={items}
                autocomplete
            />
        </Form.Part>
    );
};

TrackingCategorySelect.displayName = 'TrackingCategorySelect';
